export default "__VITE_ASSET__BkWfHXEp__"